export default __webpack_public_path__ + "static/media/2.929d74dc.jpg";